export default "__VITE_ASSET__DE$AExZJ__"